import { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { SectionHead } from "./Reveal";
import { REGISTRATION_SERVICES } from "@/data/content";
import { Check } from "lucide-react";

const RegistrationServices = () => {
    const [active, setActive] = useState(REGISTRATION_SERVICES[0].id);
    const current = REGISTRATION_SERVICES.find((s) => s.id === active);

    return (
        <section id="registration-services" className="py-24 sm:py-32 border-t border-white/10">
            <div className="max-w-7xl mx-auto px-5 sm:px-8">
                <SectionHead
                    eyebrow="Registrations & Licences"
                    title="Labour Law Registration Services"
                    sub="Registrations, amendments, renewals, closures and department coordination — handled with complete documentation."
                />
                <div className="mt-12 flex flex-wrap gap-2" data-testid="registration-tabs">
                    {REGISTRATION_SERVICES.map((s) => (
                        <button
                            key={s.id}
                            data-testid={`registration-tab-${s.id}`}
                            onClick={() => setActive(s.id)}
                            className={`px-5 py-2.5 rounded-full text-sm font-semibold transition-colors duration-200 border ${
                                active === s.id
                                    ? "bg-blue-600 border-blue-600 text-white"
                                    : "border-white/15 text-slate-300 hover:border-sky-400/50 hover:text-sky-300"
                            }`}
                        >
                            {s.label}
                        </button>
                    ))}
                </div>
                <AnimatePresence mode="wait">
                    <motion.div
                        key={current.id}
                        initial={{ opacity: 0, y: 14 }}
                        animate={{ opacity: 1, y: 0 }}
                        exit={{ opacity: 0, y: -10 }}
                        transition={{ duration: 0.35 }}
                        className="mt-8 border border-white/10 bg-[#101D3F]/50 p-8 sm:p-10"
                        data-testid="registration-panel"
                    >
                        <h3 className="font-heading text-xl font-semibold text-white">{current.label}</h3>
                        <ul className="mt-6 grid sm:grid-cols-2 lg:grid-cols-3 gap-x-8 gap-y-3.5">
                            {current.items.map((item) => (
                                <li key={item} className="flex items-start gap-2.5 text-sm text-slate-300">
                                    <Check size={15} className="text-sky-400 mt-0.5 shrink-0" />
                                    {item}
                                </li>
                            ))}
                        </ul>
                    </motion.div>
                </AnimatePresence>
            </div>
        </section>
    );
};

export default RegistrationServices;
